import PropTypes from "prop-types"
import React, {Component} from "react"

import "./Popup.scss"


class Popup extends Component {
  /*
  * Renders a dismissable Popup
  */
  constructor (props) {
    super(props)
    this.state = {hide: false}
    this.handleContainerClick = this.handleContainerClick.bind(this)
  }

  handleContainerClick(e) {
    // Only respond to clicks on the container and not child elements
    if (e.target == e.currentTarget) {
      this.setState({hide: true})
      this.props.onDismiss()
    }
  }

  render () {
    const {
      children,
      onDismiss,
      modifiers,
    } = this.props
    const classModifiers = modifiers.map(
      modifier => "popup--" + modifier
    ).join(" ")

    if (this.state.hide) {
      return <></>
    } else {
      return (
        <div className="popup__container" onClick={this.handleContainerClick}>
          <div className={`popup ${classModifiers}`}>
            <button
              className="popup__close"
              onClick={() => {
                this.setState({hide: true})
                onDismiss()
              }}
            >
            </button>
            <div className="popup__content">
              {children}
            </div>
          </div>
        </div>
      )
    }
  }
}


Popup.propTypes = {
  children: PropTypes.node,
  onDismiss: PropTypes.func,
  modifiers: PropTypes.arrayOf(PropTypes.string)
}

Popup.defaultProps = {
  modifiers: [],
  onDismiss: () => {}
}


export default Popup
